// extracted by mini-css-extract-plugin
export default {"brand":"BrandInsights_brand__i6mIB","brand_specs":"BrandInsights_brand_specs__KpVdY","partition":"BrandInsights_partition__-hZ6s"};